<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <div class="modal-detail-title clearfix">
        <span
            v-if="isHavePermission('global:viewCreateTime')"
        >签约方式：{{ formData[0].addWay | signType }} | 业务员：{{
            formData[0].salesMan
          }}{{
            formData[0].salesManager
              ? " | 销售经理：" + formData[0].salesManager
              : ""
          }}
          | 创建操作人：{{ formData[0].createUser }} | 创建日期：{{
            formData[0].createTime | timeFormatDate
          }}</span
        >
        <span
            v-else
        >签约方式：{{ formData[0].addWay | signType }} | 业务员：{{
            formData[0].salesMan
          }}{{
            formData[0].salesManager
              ? " | 销售经理：" + formData[0].salesManager
              : ""
          }}
          | 客户经理：{{ formData[0].createUser }}</span
        >
      </div>
      <vxe-table
          show-overflow
          ref="xTable1"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          :data="formData"
      >
        <vxe-table-column field="numb" title="合同号"></vxe-table-column>
        <vxe-table-column field="busType" title="业务类别">
          <template slot-scope="{ row }">
            <span>{{ row.busType | contractbusMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="title" title="订单标题"></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
        ></vxe-table-column>
        <vxe-table-column
            v-if="isSecondSeller"
            field="compName"
            title="平台企业"
        ></vxe-table-column>
      </vxe-table>
      <vxe-table
          show-overflow
          ref="xTable2"
          class="table-style"
          max-height="220"
          align="center"
          :auto-resize="true"
          :data="goodsList"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="fileList" title="附件" width="70">
          <template v-slot="{ row }">
            <upload-detail :arrList="row.fileList"></upload-detail>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.addTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="goodsName"
            title="货名"
            width="170"
        ></vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="110"
        ></vxe-table-column>
        <vxe-table-column
            field="packUnit"
            title="包装形式"
            width="80"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="55"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="115"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="115"
        ></vxe-table-column>
        <vxe-table-column
            field="amount"
            title="总金额"
            width="115"
        ></vxe-table-column>

        <vxe-table-column field="priceType" title="计费方式" width="80">
          <template slot-scope="{ row }">
            <span>{{ row.priceType | priceTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template slot-scope="{ row }">{{ row.isTax | taxMap }}</template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="130">
          <template slot-scope="{ row }">
            <span
                v-if="row.trackUrl || row.logisticsType === 2"
                @click="getMap(row)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.carShipNum }}</span
            >
            <span v-if="!row.trackUrl && row.logisticsType !== 2">{{
              row.carShipNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="130">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="130">
          <template slot-scope="{ row }">
            <span>{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          show-overflow
          :auto-resize="true"
          class="table-upload-style"
          max-height="160"
          :data="formData"
          :edit-config="{trigger: 'click', mode: 'cell'}"
      >
        <vxe-table-column field="attachFile" title="上传附件">
          <template v-slot="{row}">
            <upload-list
                :isEdit="false"
                :row="row"
                :initFileList="attachFile"
                :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button v-if="editVisible" type="primary" @click="goEdit">编 辑</Button>
    </div>
    <div v-show="trackFlag" class="trackBoxModal">
      <div style="display: flex; justify-content: space-between">
        <div
            style="
            margin-left: 10px;
            font-size: 14px;
            font-weight: bold;
            line-height: 30px;
          "
        >
          {{ isCar ? "车辆轨迹" : "船舶轨迹" }}
        </div>
        <div
            @click="trackFlag = false"
            style="
            margin-right: 5px;
            cursor: pointer;
            line-height: 30px;
            height: 30px;
            background: #409eff;
            color: #fff;
            border-radius: 5px;
            width: 60px;
            font-size: 12px;
            font-size: 12px;
            text-align: center;
          "
        >
          关闭
        </div>
      </div>
      <iframe
          ref="mapFrame"
          style="width: 96%; height: 91vh; overflow: hidden"
          frameborder="0"
          name="showHere"
          scrolling="auto"
          :src="url"
      ></iframe>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import UploadList from '@/components/common/UploadList'
  import UploadDetail from "@/components/common/UploadDetail";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import moment from "moment";

  export default {
    components: {UploadDetail,UploadList},
    mixins: [getAuthOrization],
    props: {
      editVisible: {
        type: Boolean,
        default: true,
      },
      isSecondSeller: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trackFlag: false,
        url: "",
        isCar: true,
        imageData: [],
        formData: [
          {
            type: null, //合同性质
            numb: null, // 合同号
            title: null, // 订单标题
            busType: null, // 业务类型
            addTime: null, // 签约日期
            addWay: null, //签约方式
            buyerName: null, // 托运人名称
            sellerName: null, // 承运人名称
            realBuyerName: null,
            compName: null,
            amountTotal: null, // 总金额
            createUser: null,
            createTime: null,
            platformCompanyId: null,
            salesMan: null,
            salesManId: null,
            salesManager: null,
            salesManagerId: null,
          },
        ],
        goodsList: [
          {
            goodsName: null, // 货名
            rule: null, // 规格
            unit: null, // 单位
            counts: null, // 数量
            price: null, // 单价
            isTax: null, // 是否含税
            carShipNum: null, // 车船号
            beginPlace: null, // 起运地
            endPlace: null, // 到达地
            beginTime: null, // 交货日期
            endTime: null, // 到达时间
            transportationType: null, //运输类型
            priceType: null,
            packUnit: null,
          },
        ],
        attachFile:[],
        uploadData: [
          {
            url: null,
          },
        ],
      };
    },
    methods: {
      setEditor(boolean) {
        this.editVisible = boolean;
      },
      getMap(row) {
        if (row.logisticsType === 1) {
          this.isCar = true;
          this.seeCarMap(row);
        } else {
          this.isCar = false;
          this.seeShipMap(row);
        }
      },
      seeCarMap(row) {
        let that = this;
        this.trackFlag = true;
        this.url = '/carShip/fwCarFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow;
            iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
          }, 5000);
        });
      },
      seeShipMap(row) {
        let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
        if (mmsi == null || mmsi === "") {
          //暂无数据
          this.$Message.error("暂无数据");
          return;
        }
        let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
        let deliveryDates = moment(row.endTime).format("YYYY-MM-DD");
        let obj = {
          startTime: beginTime + " 00:00:00",
          endTime: deliveryDates + " 00:00:00",
          mmsi: mmsi,
        };
        this.trackFlag = true;
        let that = this;
        if (this.url === "/carShip/fwShipFrame") {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify(obj), "*");
        } else {
          this.url = "/carShip/fwShipFrame";
          this.$nextTick(function () {
            setTimeout(function () {
              let mapFrame = that.$refs.mapFrame;
              let iframeWin = mapFrame.contentWindow;
              iframeWin.postMessage(JSON.stringify(obj), "*");
            }, 5000);
          });
        }
      },
      // 船舶日期往前推N天
      dateAddDays(dataStr, dayCount) {
        let isdate = new Date(dataStr.replace(/-/g, "/"));
        isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
        let strMonth = isdate.getMonth() + 1;
        let strDate = isdate.getDate();
        let strYear = isdate.getFullYear();
        if (strMonth >= 1 && strMonth <= 9) {
          strMonth = "0" + strMonth;
        }
        if (strDate >= 1 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return strYear + "-" + strMonth + "-" + strDate;
      },
      async queryContractDetail(id) {
        let res = await $api.agreement.request("queryContractDetail", {
          id: id,
        });
        if (res.status === 1) {
          let data = res.data;
          this.formData = [
            {
              type: data.type, //合同性质
              numb: data.numb, // 合同号
              title: data.title, // 订单标题
              busType: data.busType, // 业务类型
              addTime: data.addTime, // 签约日期
              addWay: data.addWay, //签约方式
              buyerName: data.buyerName, // 托运人名称
              sellerName: data.sellerName, // 承运人名称
              amount: data.amount, // 总金额
              createUser: data.createUser,
              createTime: data.createTime,
              compName: data.compName,
              platformCompanyId: data.platformCompanyId,
              salesMan: data.salesMan,
              salesManId: data.salesManId,
              salesManager: data.salesManager,
              salesManagerId: data.salesManagerId,
            },
          ];
          data.goodsList.map(i => {
            if (i.fileList) {
              i.fileList.map(j => {
                j.oldName = j.oldFileName;
              })
            }
          })
          this.goodsList = data.goodsList;
          this.attachFile = data.attachFile;
          if (data.fileList && data.fileList.length > 0) {
            data.fileList.map((i) => {
              this.imageData.push(i);
            });
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      goEdit() {
        this.$emit("goEdit");
      },
      close() {
        this.imageData = [];
        this.formData = [
          {
            type: null, //合同性质
            numb: null, // 合同号
            title: null, // 订单标题
            busType: null, // 业务类型
            addTime: null, // 签约日期
            addWay: null, //签约方式
            buyerName: null, // 托运人名称
            sellerName: null, // 承运人名称
            amountTotal: null, // 总金额
            createUser: null,
            createTime: null,
            compName: null,
            platformCompanyId: null,
            salesMan: null,
            salesManId: null,
            salesManager: null,
            salesManagerId: null,
          },
        ];
        this.goodsList = [
          {
            goodsName: null, // 货名
            rule: null, // 规格
            unit: null, // 单位
            counts: null, // 数量
            price: null, // 单价
            isTax: null, // 是否含税
            carShipNum: null, // 车船号
            beginPlace: null, // 起运地
            endPlace: null, // 到达地
            beginTime: null, // 交货日期
            endTime: null, // 到达时间
            transportationType: null, //运输类型
            priceType: null,
            packUnit: null,
          },
        ];
      },
    },
  };
</script>

<style>
  .ag-upload-box {
    padding: 10px;
  }

  .add-box .vxe-table .vxe-cell .ag-upload-box {
    text-indent: 0;
  }

  .modal-detail-title {
    height: 40px;
    line-height: 30px;
    margin-top: 20px;
  }

  .modal-detail-title span {
    font-size: 14px;
    color: #808695;
  }

  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .show-pic {
    position: fixed;
    z-index: 99999;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .trackBoxModal {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0px;
    top: 0;
    z-index: 999;
    background: #fff;
  }
</style>
